export class SnapshotRecipeSourceSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytes",
            "baseName": "bytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeSourceSummary.attributeTypeMap;
    }
    constructor() {
    }
}
